import React, {useEffect } from 'react'
import Modal from 'styled-react-modal'
import styled from 'styled-components'
import { FormattedMessage } from "react-intl"
import {loggedInContext} from '../auth/AuthContext'

import {
  Button,
} from '../StyledComponents.js'
import {
  Wrapper,
} from '../StyledComponents.js'
import { useCsEvent } from '../client/useEvents.js'

const StyledModal = Modal.styled`
  margin-left: auto;
  margin-right: auto;
  margin-top: 1em;
  background-color: white;
  border-color: gray;
  padding: 1em;
  width: 90vw;
  @media(min-width: 960px) {
    width: 70vw;
  }
`
const Row = styled.div`
  position: relative;
  margin-top: 1em;
`
const FormButton = styled(Button)`
    font-family: NeueEinstellungBold;
    text-align: center;
    white-space: nowrap;
    line-height: 1.5;
    font-size: 1.6rem;
    background-color: rgb(139, 125, 101);
    border: 0.1rem solid rgb(139, 125, 101);
    color: white;
    outline: 0px;
    display: block;
    font-weight: 500;
}
`

function Component(props) {
  const fireCsEvent = useCsEvent()
  const { loggedIn, openLoginModal, user } = React.useContext(loggedInContext) 

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    props.onClose && props.onClose()
  }

  const onDusun = () => {
    fireCsEvent({
      category: "Gazete",
      action: "Eylem",
      label: "Dusuneyim butonuna basildi"
    })
    closeModal()
  }

  //bunu sadece clientta yapmak gerekiyor
  useEffect(() => {
    fireCsEvent({
      category: 'Gazete',
      action: "Eylem",
      label: "Download patreon modal görüldü"
    })
  }, [])

  return <StyledModal
    isOpen={true}
    afterOpen={afterOpenModal}
    onEscapeKeydown={closeModal}
    onBackgroundClick={closeModal}
    contentLabel="Login Popup"
  >
    <Wrapper>
      <h1 className="text-center">
        <FormattedMessage id="patreonModal.cta" />
      </h1>
      <Row>
        <p><FormattedMessage id="patreonModal.p1" /></p> 
      </Row>
      <stripe-pricing-table pricing-table-id={process.env.REACT_APP_GA_SUBS_TABLE_ID}
    publishable-key={process.env.REACT_APP_GA_SUBS_PRICING_KEY}
      client-reference-id={user?.id}>
      </stripe-pricing-table>
      <Row className='d-flex justify-content-center'>
        <FormButton onClick={onDusun} style={{ backgroundColor: '#f0f0f0', color: '#555', border: 'none', marginTop: '1rem' }}>
          <FormattedMessage id="patreonModal.cancel" />
        </FormButton>
      </Row>
    </Wrapper>
  </StyledModal>
}

export default Component
